<template>
    <nav class="navbar fixed-top d-block d-md-block d-lg-none navbar__md">
        <div class="container">
            <a href="javascript:void(0)" @click="menuToggle(1)" class="nav-link">
                <img
                src="@/assets/images/icons/menu.png"
                alt="notifications"
                class="img-fluid"
                style="height: 2.16rem"
                />
            </a>
            <div class="d-flex align-items-center">
                <!-- Languages -->
                <LanguageSwitcher></LanguageSwitcher>
                <div>
                    <label>
                        <input
                        class="form-control"
                        type="search"
                        :placeholder="$t('default.header.search')"
                        aria-label="Search"
                        />
                    </label>
                </div>
            </div>
        </div>
        <div class="navigation-overlay" id="myNav">
            <div class="text-left mb-3 mb-sm-4 ">
                <a href="javascript:void(0)" class="closebtn" @click="menuToggle(0)">
                <img src="@/assets/images/icons/close.png" alt="" />
                </a>
            </div>
            <div class="overlay-content d-flex">
                <DropDownMenu v-bind:menus="menus" v-bind:class="'w-100'"/>
            </div>
        </div>
    </nav>
</template>
<script>
import DropDownMenu from '@/components/core/Navigation/DropDown/DropDownMenu.vue'
import LanguageSwitcher from '@/components/core/LanguageSwitcher'

export default {
  name: 'TheHeaderMd',

  props: ['menus'],

  components: {
    LanguageSwitcher,
    DropDownMenu
  },

  methods: {
    menuToggle (p) {
      const navMd = document.querySelector('#myNav')
      const sm = window.matchMedia('(max-width: 576px)')
      if (p === 1) {
        const navbarWidth = document.querySelector('.navbar__md.navbar')
        if (sm.matches) {
          navMd.style.right = '5%'
        }
        navMd.style.margin = '8px 0px 0'
        navMd.style.top = '0'
        navMd.style.width = navbarWidth
        navMd.style.height = 'auto'
        navMd.style.transition = '0.6s cubic-bezier(0.86, 0, 0.07, 1)'
      } else {
        navMd.style.height = '0%'
        navMd.style.top = '-250px'
        navMd.style.transition = '0.6s cubic-bezier(0.86, 0, 0.07, 1)'
      }
    }
  }
}
</script>
